import { render, staticRenderFns } from "./AdminSubject.vue?vue&type=template&id=7c6d8e12&scoped=true"
import script from "./AdminSubject.vue?vue&type=script&lang=js"
export * from "./AdminSubject.vue?vue&type=script&lang=js"
import style0 from "./AdminSubject.vue?vue&type=style&index=0&id=7c6d8e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6d8e12",
  null
  
)

export default component.exports